import { lazy } from 'react';
import {
	AlertsPrimaryDarkIcon, AlertsPrimaryIcon, AutomationPrimaryDarkIcon, AutomationPrimaryIcon, ChangepasswordPrimaryDarkIcon, ChangepasswordPrimaryIcon, ContactsPrimaryDarkIcon, ContactsPrimaryIcon, ConversationsPrimaryDarkIcon, ConversationsPrimaryIcon, DashboardPrimaryDarkIcon, DashboardPrimaryIcon, FalkonAiPurpleIcon, FeaturesPrimaryDarkIcon, FeaturesPrimaryIcon, GroupsPrimaryDarkIcon, GroupsPrimaryIcon,
	IntegrationPrimaryDarkIcon,
	IntegrationPrimaryIcon,
	KafkaPrimaryDarkIcon, KafkaPrimaryIcon, OrganizationsPrimaryDarkIcon, OrganizationsPrimaryIcon, PhoneGroupPrimaryDarkIcon, PhoneGroupPrimaryIcon, PhoneNumbersPrimaryDarkIcon, PhoneNumbersPrimaryIcon, PlansPrimaryDarkIcon, PlansPrimaryIcon, ReportsPrimaryDarkIcon, ReportsPrimaryIcon, ScheduleMessagePrimaryDarkIcon, ScheduleMessagePrimaryIcon, SecureChatActiveIcon, SecureChatGreyIcon, SecureFilePrimaryDarkIcon, SecureFilePrimaryIcon,
	SettingsPrimaryDarkIcon, SettingsPrimaryIcon,
	TemplatesPrimaryDarkIcon, TemplatesPrimaryIcon, TiersPrimaryDarkIcon, TiersPrimaryIcon, TransferPrimaryDarkIcon, TransferPrimaryIcon, UsersPrimaryDarkIcon, UsersPrimaryIcon, FalkonDocIcon, FalkonDocPrimaryIcon,
	FalkonAiMoniteringIcon
} from '../../icon';
import { PlanMetrics, UserPlanTracker } from '../../models/plan-metrics.model';
import { RouteModel } from "../../models/routes.model";
import { WebRoutes } from './route.path';
// import GroupDeletionInfo from '../groups/group-deletion-info.component'
import { withErrorBoundaries } from '../shared/error-handler.component';
import store from '../../stores/app-store';

// const Dashboard = lazy(() => import("../dashboard/dashboard-view.component"));
// const Plans = lazy(() => import('../plans/plans.component'));
// const Organization = lazy(() => import("../organizations/organization.component"));
// const AlertsComponent = lazy(() => import('../alerts/alerts.component'));
// const AutoAlertKeyword = lazy(() => import("../auto-alerts/keywords.component"));
// const AutoAlertLogs = lazy(() => import("../auto-alerts/logs.component"));
// const AutoAlertRules = lazy(() => import("../auto-alerts/rules.component"));
// const Contacts = lazy(() => import("../contacts/contact.component"));
// const ImportContactsContainer = lazy(() => import('../contacts/import-contact-container.component'));
// const ImportContacts = lazy(() => import("../contacts/import-dailog.component.new"));
// const ConversationComponent = lazy(() => import('../conversations/conversation-component'));
// const Features = lazy(() => import("../features/feature.component"));
// const Groups = lazy(() => import("../groups"));
// const KafkaComponent = lazy(() => import("../kafka-component"));
// const PaymentStatusComponent = lazy(() => import('../payment/payment-status.component'));
// const PhoneNumber = lazy(() => import("../phone-numbers/phone-number.component"));
// const AddPhoneNumber = lazy(() => import("../add-phone-number"));
// const PlanHistory = lazy(() => import("../plans/plans-history.component"));
// const Changepassword = lazy(() => import("../profile/change-password.component"));
// const Profile = lazy(() => import("../profile/profile.component"));
// const Recharge = lazy(() => import("../recharge"));
// const Reports = lazy(() => import('../reports/index'));
// const ScheduledMessage = lazy(() => import('../scheduled-messages/scheduled-messages.component'));
// const Settings = lazy(() => import("../settings/settings.component"));
// const TemplateComponent = lazy(() => import('../templates'));
// const Tiers = lazy(() => import("../tiers/tier.component"));
// const Transfers = lazy(() => import("../transfers"));
// const User = lazy(() => import("../users/user.component"));
// const Integrations = lazy(() => import('../integrations'));
// const MSTeamsChannelSetup = lazy(() => import('../integrations/teams/channel-setup'));
// const CreditLogsComponent = lazy(() => import("../reports/credit-logs-component"));
// const ExportMsgLogComponent = lazy(() => import("../reports/message-logs/export-msg-log-component"));
// const MessageLogs = lazy(() => import("../reports/message-logs/message-logs.component"));
// const SecureFileEmailAuthentication = lazy(() => import('../secure-file/secure-file-email-authentication'));
// const ViewTierComponent = lazy(() => import("../tiers/view-tier"));
// const ClioCallback = lazy(() => import('../integrations/clio/clio-callback'));
// const HubSpotCallback = lazy(() => import('../integrations/hubspot/hubspot-callback'));
// const MSActivityFeedSetup = lazy(() => import('../integrations/teams-activity-feed-notification/activity-feed-setup'));
// const SecureFiles = lazy(() => import('../secure-file'));
// const FaceRegister = lazy(() => import('../secure-file/face-register.component'));
// const FaceVerification = lazy(() => import('../secure-file/face-verification.component'));
// const FalkonSecureChat = lazy(() => import('../secure-chat'));
// const OutlookCallback = lazy(() => import('../integrations/Outlook/outlook-callback'));
// const OptOutPolicy = lazy(() => import('../reports/optout-policy.component'));
// const BlockedContact = lazy(() => import('../reports/blocked-contacts.component'));
// const SlackCallback = lazy(() => import('../integrations/slack/slack-callback'));
// const FalkonAi = lazy(() => import('../falkon-ai'));
// const TwofactorAuthentication = lazy(() => import('../login/twofactor-authentication.component'))
// const ForgotPassword = lazy(() => import('../login/forgot-password.component'))
// const ResetPassword = lazy(() => import('../login/reset-password.component'))
// const SsoInactive = lazy(() => import('../shared/sso-inactive.component'))
// const Login = lazy(() => import('../login/login.component'))
// const Signup = lazy(() => import('../signup/index'))

import Dashboard from "../dashboard/dashboard-view.component";
import Plans from '../plans/plans.component';
import Organization from "../organizations/organization.component";
import AlertsComponent from '../alerts/alerts.component';
import AutoAlertRules from "../auto-alerts/rules.component";
import Contacts from "../contacts/contact.component";
import ImportContactsContainer from '../contacts/import-contact-container.component';
import ImportContacts from "../contacts/import-dailog.component.new";
import ConversationComponent from '../conversations/conversation-component';
import Features from "../features/feature.component";
import Groups from "../groups";
import KafkaComponent from "../kafka-component";
import PaymentStatusComponent from '../payment/payment-status.component';
import PhoneNumber from "../phone-numbers/phone-number.component";
import AddPhoneNumber from "../add-phone-number";
import PlanHistory from "../plans/plans-history.component";
import Changepassword from "../profile/change-password.component";
import Profile from "../profile/profile.component";
import Recharge from "../recharge";
import Reports from '../reports/index';
import ScheduledMessage from '../scheduled-messages/scheduled-messages.component';
import Settings from "../settings/settings.component";
import TemplateComponent from '../templates';
import Tiers from "../tiers/tier.component";
import Transfers from "../transfers";
import User from "../users/user.component";
import Integrations from '../integrations';
import MSTeamsChannelSetup from '../integrations/teams/channel-setup';
import CreditLogsComponent from "../reports/credit-logs-component";
import ExportMsgLogComponent from "../reports/message-logs/export-msg-log-component";
import MessageLogs from "../reports/message-logs/message-logs.component";
import SecureFileEmailAuthentication from '../secure-file/secure-file-email-authentication';
import ViewTierComponent from "../tiers/view-tier";
import ClioCallback from '../integrations/clio/clio-callback';
import HubSpotCallback from '../integrations/hubspot/hubspot-callback';
import MSActivityFeedSetup from '../integrations/teams-activity-feed-notification/activity-feed-setup';
import SecureFiles from '../secure-file';
import FaceRegister from '../secure-file/face-register.component';
import FaceVerification from '../secure-file/face-verification.component';
import FalkonSecureChat from '../secure-chat';
import OutlookCallback from '../integrations/Outlook/outlook-callback';
import OptOutPolicy from '../reports/optout-policy.component';
import BlockedContact from '../reports/blocked-contacts.component';
import SlackCallback from '../integrations/slack/slack-callback';
import FalkonAi from '../falkon-ai';
import PhoneNumberGroups from '../PhoneNumberGroup';
import TwofactorAuthentication from '../login/twofactor-authentication.component';
import ForgotPassword from '../login/forgot-password.component';
import ResetPassword from '../login/reset-password.component';
import SsoInactive from '../shared/sso-inactive.component';
import Login from '../login/login.component';
import Signup from '../signup/index';
import SecureDocs from '../falkon-docs/index';
import SecureDocsUploads from '../falkon-docs/falkon-docs-uploads';
import DisplaySuccessMaessageComponent from '../falkon-docs/display-success-message.component';
import FalkonSecureDocOtp from '../falkon-docs/secure-doc-otp-verification.component';
import EndUserSigningComponent from '../falkon-docs/end-user-signing.component';
import DisplaySignerSuccessMaessageComponent from '../falkon-docs/display-signer-success-message.component';
import FalkonSignedSecureDocOtp from '../falkon-docs/signed-secure-doc-otp-verification.component';
import CompletedPDFViewerComponent from '../falkon-docs/completed-secure-doc-view.component';
import AiAnalytics from '../falkon-ai/monitering';
import ImportScheduleMessages from '../scheduled-messages/import-schedule-messages';

import NewPlans from '../new-subscription-flow/NewPlans';
import CreateEditPlan from '../new-subscription-flow/CreateEditPlan';
import NewOrganization from '../new-Organizations/NewOrganization';
import NewPhoneNumbers from '../new-PhoneNumbers/NewPhoneNumbers';
import NewUsers from '../new-Users/NewUsers';
import ImportUsersComponent from '../new-Users/import-users.component';
import UserImportReports from '../new-Users/UserImportReports';
import NewNumberBulkImportComponent from '../new-PhoneNumbers/NewNumberBulkImportComponent';
import PhoneHostImportReports from '../new-PhoneNumbers/PhoneHostImportReports';
import NewRecharge from '../new Recharge/NewRecharge';
import NewAddPhoneNumber from '../new-PhoneNumbers/NewAddPhoneNumber';
import { LocalStorage } from '../../services/UtilityService';
import OrgPlanHistoryComponent from '../new-Organizations/planHistory';
import NewPaymentStatus from '../new-PhoneNumbers/NewPaymentStatus';
import AccountBilling from '../account-billing/Account-billing';
import CustomAttributesComponent from '../contacts/custom-attributes.component';
import StepperImportNewComponent from '../contacts/stepper-import.newcomponent';
import SecureChatMessageLogs from '../reports/message-logs/secure-chat-message-logs';
import SecureChatExportMsgLogsComponent from '../reports/message-logs/secure-chat-export-history.component';
import WebForm from '../web-forms';
import WebFormHistory from '../web-forms/webform-histoy.component';
import EndUserWebFormComponent from '../web-forms/end-user-webform.component';

let existing_routes: RouteModel[] = [];
let user_id: string = "";

export const Routes = () => {
	const currentUser = LocalStorage.get("current-user")
	const isNewSubFlow = currentUser?.isNewSubFlow ?? false
	const userId = currentUser?.id ?? ""
	if (existing_routes?.length === 0 || user_id !== userId) {
		const routes: RouteModel[] = [
			{
				id: 1,
				label: "Dashboard",
				path: WebRoutes.DASHBOARD,
				component: withErrorBoundaries(Dashboard, "Dashboard"),
				primaryIcon: DashboardPrimaryIcon,
				primaryDarkIcon: DashboardPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 2,
				label: isNewSubFlow ? "Phone Lines" : "Phone Lines",
				path: `${WebRoutes.PLANS}/*`,
				component: withErrorBoundaries(Plans, "Plans"),
				primaryIcon: PlansPrimaryIcon,
				primaryDarkIcon: PlansPrimaryDarkIcon,
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: true,
				isUserMenu: true
			},
			{
				id: 3,
				label: "Organizations",
				path: WebRoutes.ORGANIZATIONS,
				component: withErrorBoundaries(Organization, "Organizations"),
				primaryIcon: OrganizationsPrimaryIcon,
				primaryDarkIcon: OrganizationsPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 4,
				label: "Phone Numbers",
				path: `${WebRoutes.PHONE_NUMBERS}/*`,
				component: withErrorBoundaries(PhoneNumber, "Phone Numbers"),
				primaryIcon: PhoneNumbersPrimaryIcon,
				primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 51,
				label: "Line Groups",
				path: WebRoutes.PHONENUMBER_GROUPS_SYSADM,
				component: withErrorBoundaries(PhoneNumberGroups, "Line Groups"),
				roles: [1],
				primaryIcon: PhoneGroupPrimaryIcon,
				primaryDarkIcon: PhoneGroupPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
			},
			{
				id: 5,
				label: "Users",
				path: isNewSubFlow ? WebRoutes.NEW_USERS : WebRoutes.USERS,
				component: withErrorBoundaries(isNewSubFlow ? NewUsers : User, "Users"),
				primaryIcon: UsersPrimaryIcon,
				primaryDarkIcon: UsersPrimaryDarkIcon,
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 6,
				label: "Conversations",
				path: `${WebRoutes.CONVERSATIONS}/*`,
				component: withErrorBoundaries(ConversationComponent, "Conversations"),
				primaryIcon: ConversationsPrimaryIcon,
				primaryDarkIcon: ConversationsPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				highlightDataKey: "unreadMessageCount",
				enableHighlight: true,
				hasSubRoutes: false,
				exact: true,
			},
			{
				id: 102,
				label: "Secure Chat",
				path: `${WebRoutes.SECURE_CONVERSATIONS}/*`,
				component: withErrorBoundaries(ConversationComponent, "Conversations"),
				primaryIcon: SecureChatGreyIcon,
				primaryDarkIcon: SecureChatActiveIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				highlightDataKey: "secureChatUnReadMessageCount",
				enableHighlight: true,
				hasSubRoutes: false,
				exact: true,
				PlanFilter: "HasAccessToSecureChat",
			},
			{
				id: 7,
				label: "Scheduled Messages",
				path: WebRoutes.SCHEDULED_MESSAGES,
				component: withErrorBoundaries(ScheduledMessage, "Scheduled Messages"),
				primaryIcon: ScheduleMessagePrimaryIcon,
				primaryDarkIcon: ScheduleMessagePrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				enableHighlight: true,
				PlanFilter: "HasMessageScheduling",
				exact: true,
			},
			{
				id: 8,
				label: "Contacts",
				path: WebRoutes.CONTACTS,
				component: withErrorBoundaries(Contacts, "Contacts"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				exact: true
			},
			{
				id: 9,
				label: "Groups (Campaigns)",
				path: WebRoutes.GROUPS,
				component: withErrorBoundaries(Groups, "Groups"),
				primaryIcon: GroupsPrimaryIcon,
				primaryDarkIcon: GroupsPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				exact: true,
				PlanFilter: isNewSubFlow ? "HasGroupBroadcast" : ""
			},
			{
				id: 10,
				label: "Transfer Credits",
				path: `${WebRoutes.TRANSFERS}/*`,
				component: withErrorBoundaries(Transfers, "Transfer Credits"),
				roles: [2, 3, 4],
				primaryIcon: TransferPrimaryIcon,
				primaryDarkIcon: TransferPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true,
			},
			{
				id: 11,
				label: "Change Password",
				path: WebRoutes.CHANGE_PASSWORD,
				component: withErrorBoundaries(Changepassword, "Change Password"),
				primaryIcon: ChangepasswordPrimaryIcon,
				primaryDarkIcon: ChangepasswordPrimaryDarkIcon,
				roles: [1, 2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true
			},
			{
				id: 12,
				label: "Settings",
				path: `${WebRoutes.SETTINGS}/*`,
				component: withErrorBoundaries(Settings, "Settings"),
				primaryIcon: SettingsPrimaryIcon,
				primaryDarkIcon: SettingsPrimaryDarkIcon,
				roles: [1, 2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true,
				exact: true,
			},
			{
				id: 13,
				label: "Profile",
				path: WebRoutes.PROFILE,
				component: withErrorBoundaries(Profile, "Profile"),
				roles: [1, 2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 14,
				label: "Plans",
				path: WebRoutes.TIERS,
				component: withErrorBoundaries(Tiers, "Plans"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true,
				exact: true
			},
			{
				id: 15,
				label: "Features",
				path: WebRoutes.FEATURES,
				component: withErrorBoundaries(Features, "Features"),
				primaryIcon: FeaturesPrimaryIcon,
				primaryDarkIcon: FeaturesPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 16,
				label: "Add Number",
				path: WebRoutes.ADD_PHONE_NUMBER,
				component: withErrorBoundaries(AddPhoneNumber, "Add Number"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 17,
				label: "",
				path: WebRoutes.PAYMENT_STATUS,
				component: withErrorBoundaries(PaymentStatusComponent, "Payment Status"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 18,
				label: "Recharge",
				path: WebRoutes.RECHARGE,
				component: withErrorBoundaries(Recharge, "Recharge"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 19,
				label: "Alerts",
				path: WebRoutes.ALERTS,
				component: withErrorBoundaries(AlertsComponent, "Alerts"),
				primaryIcon: AlertsPrimaryIcon,
				primaryDarkIcon: AlertsPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 20,
				label: "Rehost Phone Number",
				path: WebRoutes.REHOST,
				component: withErrorBoundaries(AddPhoneNumber, "Rehost"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 21,
				label: "Automation Rules",
				path: `${WebRoutes.AUTOMATION_RULES}/*`,
				component: withErrorBoundaries(AutoAlertRules, "Automation Rules"),
				roles: [2, 3, 4],
				primaryIcon: AutomationPrimaryIcon,
				primaryDarkIcon: AutomationPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
				exact: true,
				PlanFilter: "HasAccessAutoReplies",
			},
			{
				id: 22,
				label: "Falkon Sign",
				path: WebRoutes.FALKON_DOCS,
				component: withErrorBoundaries(SecureDocs, "Falkon Sign"),
				primaryIcon: FalkonDocPrimaryIcon,
				primaryDarkIcon: FalkonDocIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				exact: true,
				PlanFilter: "HasAccessToSecureDoc",
			},
			{
				id: 23,
				label: "Templates",
				path: `${WebRoutes.TEMPLATES}/*`,
				component: withErrorBoundaries(TemplateComponent, "Templates"),
				primaryIcon: TemplatesPrimaryIcon,
				primaryDarkIcon: TemplatesPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 24,
				label: "Import Contacts",
				path: WebRoutes.IMPORT_CONTACTS,
				component: withErrorBoundaries(ImportContactsContainer, "import-contacts"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 25,
				label: "Plan History",
				path: WebRoutes.PHONE_NUMBERS_PLAN_HISTORY,
				component: withErrorBoundaries(PlanHistory, "plan-history"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				// secondaryIcon: ContactsPrimaryIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 26,
				label: "Plan History",
				path: WebRoutes.PLANS_PLAN_HISTORY,
				component: withErrorBoundaries(PlanHistory, "plan-history"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				// secondaryIcon: ContactsPrimaryIcon,
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			// {
			// 	id: 27,
			// 	label: "Switch Phone Number",
			// 	path: WebRoutes.SWITCH_PHONE_NUMBER,
			// 	component: withErrorBoundaries(SwitchPhoneNumber, "SwitchPhoneNumber"),
			// 	roles: [2],
			// 	authenticationRequired: true,
			// 	isSideMenu: false,
			// 	isUserMenu: true
			// },
			{
				id: 28,
				label: "Kafka Cluster",
				path: WebRoutes.KAFKA_CLUSTER,
				component: withErrorBoundaries(KafkaComponent, "Kafka Cluster"),
				primaryIcon: KafkaPrimaryIcon,
				primaryDarkIcon: KafkaPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},

			{
				id: 29,
				label: "Import Contacts from Excel",
				path: WebRoutes.IMPORT_CONTACTS_EXCEL,
				component: withErrorBoundaries(StepperImportNewComponent, "import-contacts-excel"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 31,
				label: "Secure Files",
				path: `${WebRoutes.SECURE_FILE}/*`,
				component: withErrorBoundaries(SecureFiles, "Secure file"),
				primaryIcon: SecureFilePrimaryIcon,
				primaryDarkIcon: SecureFilePrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true,
				PlanFilter: "HasAccessToSecureFiles"
			},
			{
				id: 32,
				label: "Secure Files Redirect",
				path: WebRoutes.SECURE_FILE_REDIRECT,
				component: withErrorBoundaries(SecureFileEmailAuthentication, "Secure file redirect"),
				primaryIcon: SecureFilePrimaryIcon,
				primaryDarkIcon: SecureFilePrimaryDarkIcon,
				roles: [2, 3, 4],
				exact: true,
				authenticationRequired: false,
				isSideMenu: false
			},
			// {
			// 	id: 33,
			// 	label: "Conversations",
			// 	path: WebRoutes.CONVERSATION_HISTORY,
			// 	component: withErrorBoundaries(ConversationComponent, "Conversations"),
			// 	primaryIcon: ConversationsPrimaryIcon,
			// 	primaryDarkIcon: ConversationsPrimaryDarkIcon,
			// 	roles: [2, 3],
			// 	authenticationRequired: true,
			// 	isSideMenu: false,
			// 	highlightDataKey: "unreadMessageCount",
			// 	enableHighlight: true,
			// 	exact: true,
			// },
			{
				id: 34,
				label: "Reports",
				path: WebRoutes.REPORTS,
				component: withErrorBoundaries(Reports, "Reports"),
				roles: [3],
				primaryIcon: ReportsPrimaryIcon,
				primaryDarkIcon: ReportsPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
			},
			{
				id: 35,
				label: "Reports",
				path: WebRoutes.REPORTS,
				component: withErrorBoundaries(Reports, "Reports"),
				roles: [2, 4],
				primaryIcon: ReportsPrimaryIcon,
				primaryDarkIcon: ReportsPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
				hasSubRoutes: true,
				hide: false,
				children: [{
					id: 1,
					label: "Broadcast & Schedule Logs",
					subRouteLabel: "Schedule Broadcast Logs",
					path: WebRoutes.REPORTS,
					component: withErrorBoundaries(Reports, "Reports"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 2,
					label: "Secure Chat - Message Logs",
					subRouteLabel: "Secure Chat - Message Logs",
					path: WebRoutes.SECURE_CHAT_MESSAGE_LOGS,
					component: withErrorBoundaries(SecureChatMessageLogs, "SecureChat Message-Logs"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 3,
					label: "Message Logs",
					subRouteLabel: "Message Logs",
					path: WebRoutes.MESSAGE_LOGS,
					component: withErrorBoundaries(MessageLogs, "Message-Logs"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 4,
					label: "Credit Logs",
					subRouteLabel: "Credit Logs",
					path: WebRoutes.CreditLog,
					component: withErrorBoundaries(CreditLogsComponent, "Reports - Credit Logs"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true,
					hide: isNewSubFlow
				},
				{
					id: 5,
					label: "Opt-Out List",
					subRouteLabel: "Opt-Out List",
					path: WebRoutes.OPTOUT_POLICY,
					component: withErrorBoundaries(OptOutPolicy, "Opt-Out List"),
					roles: [2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true,
					// PlanFilter: "hasOrgwideOptout"
				},
				{
					id: 6,
					label: "Blocked List",
					subRouteLabel: "Blocked List",
					path: WebRoutes.BLOCKED_CONTACTS_LIST,
					component: withErrorBoundaries(BlockedContact, "Blocked List"),
					roles: [2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true,
					hide: isNewSubFlow ? "HasBlockList" : false
				},
				{
					id: 7,
					label: "Export History",
					subRouteLabel: "Export History",
					path: WebRoutes.ExportReport,
					component: withErrorBoundaries(ExportMsgLogComponent, "Reports - Export History"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				},
				{
					id: 8,
					label: "Secure Chat Export History",
					subRouteLabel: "Secure Chat - Export History",
					path: WebRoutes.SecureChat_ExportReport,
					component: withErrorBoundaries(SecureChatExportMsgLogsComponent, "Secure Chat - Export History"),
					roles: [1, 2, 3, 4],
					authenticationRequired: true,
					isSideMenu: true
				}
				].filter(x => isNewSubFlow ? !x.hide === isNewSubFlow : x)
			},

			{
				id: 36,
				label: "Credit Logs",
				path: WebRoutes.CreditLog,
				component: withErrorBoundaries(CreditLogsComponent, "Credit Logs"),
				roles: [1],
				primaryIcon: ReportsPrimaryIcon,
				primaryDarkIcon: ReportsPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
			},
			{
				id: 37,
				label: "Add Plan",
				path: WebRoutes.ADD_PLAN,
				component: withErrorBoundaries(ViewTierComponent, "Add Plan"),
				roles: [1],
				primaryIcon: ReportsPrimaryIcon,
				primaryDarkIcon: ReportsPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 38,
				label: "Integrations",
				path: WebRoutes.INTEGRATIIONS,
				component: withErrorBoundaries(Integrations, "Integrations"),
				roles: [2, 4],
				primaryIcon: IntegrationPrimaryIcon,
				primaryDarkIcon: IntegrationPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: true,
				isUserMenu: false,
				exact: true
			},
			{
				id: 39,
				label: "Teams Channel Setup",
				path: WebRoutes.TEAMS_CHANNEL_SETUP,
				component: withErrorBoundaries(MSTeamsChannelSetup, "Teams Channel Setup"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true,
				exact: true
			},
			{

				id: 40,
				label: "Teams Activity Feed Setup",
				path: WebRoutes.TEAMS_ACTIVITY_FEED,
				component: withErrorBoundaries(MSActivityFeedSetup, "Teams Activity Feed Setup"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true,
				exact: true
			},
			{
				id: 41,
				label: "Clio ",
				path: WebRoutes.CLIO,
				component: withErrorBoundaries(ClioCallback, "Clio"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 42,
				label: "HubSpot",
				path: WebRoutes.HUBSPOT,
				component: withErrorBoundaries(HubSpotCallback, "HubSpot"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 43,
				label: "Slack Channel Setup",
				path: WebRoutes.SLACK,
				component: withErrorBoundaries(SlackCallback, "Slack Channel Setup"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: true,
				exact: true
			},

			{
				id: 44,
				label: "Login",
				path: WebRoutes.SIGN_IN,
				component: withErrorBoundaries(Login, "Sign In"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 45,
				label: "SignUp",
				path: WebRoutes.SIGN_UP,
				component: withErrorBoundaries(Signup, "Sign-Up"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 46,
				label: "2FA",
				path: WebRoutes.TWO_FACTOR_AUTHENTICATION,
				component: withErrorBoundaries(TwofactorAuthentication, "2FA"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 47,
				label: "Forgot Password",
				path: WebRoutes.FORGOT_PASSWORD,
				component: withErrorBoundaries(ForgotPassword, "forgotPassword"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 48,
				label: "Reset Password",
				path: WebRoutes.RESET_PASSWORD_NEW,
				component: withErrorBoundaries(ResetPassword, "resetPassword"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 49,
				label: "SSO error",
				path: WebRoutes.SSO_ERROR_PAGE,
				component: withErrorBoundaries(SsoInactive, "ssoError"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 50,
				label: "Face Registration",
				path: WebRoutes.FACE_REGISTRATION,
				component: withErrorBoundaries(FaceRegister, "faceRegistartion"),
				roles: [2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 51,
				label: "Face Verification",
				path: WebRoutes.FACE_VERIFICATION,
				component: withErrorBoundaries(FaceVerification, "faceVerification"),
				roles: [2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 52,
				label: "Falkon Secure Chat",
				path: WebRoutes.FALKON_SECURE_CHAT,
				component: withErrorBoundaries(FalkonSecureChat, "Falkon Secure Chat"),
				roles: [1, 2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false,
				PlanFilter: "HasSecureChats"
			},
			{
				id: 53,
				label: "Outlook Integration",
				path: WebRoutes.OUTLOOK,
				component: withErrorBoundaries(OutlookCallback, "Outlook integration"),
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
			},
			{
				id: 54,
				label: "Falkon AI",
				path: WebRoutes.FALKON_AI,
				component: withErrorBoundaries(FalkonAi, "Falkon AI"),
				primaryIcon: FalkonAiPurpleIcon,
				primaryDarkIcon: FalkonAiPurpleIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 1120,
				label: "Import Scheduled Messages",
				path: WebRoutes.IMPORT_SCHEDULED_MESSAGES,
				component: withErrorBoundaries(ImportScheduleMessages, "Import Scheduled Messages"),
				primaryIcon: FalkonAiPurpleIcon,
				primaryDarkIcon: FalkonAiPurpleIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 55,
				label: "Falkon Sign",
				path: WebRoutes.FALKON_DOCS_UPLOADS,
				component: withErrorBoundaries(SecureDocsUploads, "Falkon Sign Uploads"),
				primaryIcon: FalkonDocPrimaryIcon,
				primaryDarkIcon: FalkonDocIcon,
				roles: [2, 3],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 56,
				label: "",
				path: WebRoutes.FALKON_DOCS_SUCCESS,
				component: withErrorBoundaries(DisplaySuccessMaessageComponent, "Falkon Sign Configure Success"),
				roles: [2, 3],
				authenticationRequired: true,
				isSideMenu: false,
			},
			{
				id: 57,
				label: "",
				path: WebRoutes.FALKON_DOCS_OTP,
				component: withErrorBoundaries(FalkonSecureDocOtp, "Falkon Sign Otp"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 58,
				label: "",
				path: WebRoutes.FALKON_DOCS_END_USER_SIGN,
				component: withErrorBoundaries(EndUserSigningComponent, "Falkon Sign End User Sign"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 59,
				label: "",
				path: WebRoutes.FALKON_DOCS_END_USER_SIGN_SUCCESS,
				component: withErrorBoundaries(DisplaySignerSuccessMaessageComponent, "Falkon Sign End User Sign Success"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 60,
				label: "",
				path: WebRoutes.FALKON_DOCS_VERIFY_OTP,
				component: withErrorBoundaries(FalkonSignedSecureDocOtp, "Falkon Sign End User Verify OTP"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 61,
				label: "",
				path: WebRoutes.FALKON_DOCS_COMPLETED,
				component: withErrorBoundaries(CompletedPDFViewerComponent, "Completed Falkon Sign"),
				roles: [2, 3],
				authenticationRequired: false,
				isSideMenu: false,
			},
			{
				id: 60,
				label: "New Organizations",
				path: WebRoutes.NEW_ORGANIZATION,
				component: withErrorBoundaries(NewOrganization, "New Organizations"),
				primaryIcon: OrganizationsPrimaryIcon,
				primaryDarkIcon: OrganizationsPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 63,
				label: "New Phone Numbers",
				path: WebRoutes.NEW_PhONE_NUMBER,
				component: withErrorBoundaries(NewPhoneNumbers, "new Phone Numbers"),
				primaryIcon: PhoneNumbersPrimaryIcon,
				primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 64,
				label: "New Users",
				path: WebRoutes.NEW_USERS,
				component: withErrorBoundaries(NewUsers, "New Users"),
				primaryIcon: UsersPrimaryIcon,
				primaryDarkIcon: UsersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 65,
				label: "New Plans",
				path: WebRoutes.NEW_PLANS,
				component: withErrorBoundaries(NewPlans, "new Plans"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true,
				exact: true
			},
			{
				id: 66,
				label: "Add plan",
				path: WebRoutes.ADD_NEW_PLAN,
				component: withErrorBoundaries(CreateEditPlan, "createOrEditPlan"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 67,
				label: "New Recharge",
				path: WebRoutes.NEW_RECHARGE,
				component: withErrorBoundaries(NewRecharge, "New Reacherge"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 68,
				label: "Add Number",
				path: WebRoutes.NEW_ADD_PHONE_NUMBER,
				component: withErrorBoundaries(NewAddPhoneNumber, "NewAddPhoneNumbers"),
				primaryIcon: TiersPrimaryIcon,
				primaryDarkIcon: TiersPrimaryDarkIcon,
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 69,
				label: "Seat History",
				path: WebRoutes.ORGANIZATION_PLAN_HISTORY,
				component: withErrorBoundaries(OrgPlanHistoryComponent, "Seat-history"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				// secondaryIcon: ContactsPrimaryIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 70,
				label: "",
				path: WebRoutes.NEW_PAYMENT_STATUS,
				component: withErrorBoundaries(NewPaymentStatus, "Payment Status"),
				roles: [1, 2, 4],
				authenticationRequired: true,
				isSideMenu: false
			},
			{
				id: 71,
				label: "Account & Billing",
				path: `${WebRoutes.ACCOUNT_BILLING}`,
				component: withErrorBoundaries(AccountBilling, "Account Billing"),
				primaryIcon: TemplatesPrimaryIcon,
				primaryDarkIcon: TemplatesPrimaryDarkIcon,
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: true,
				hide: isNewSubFlow ? false : true
			},
			{
				id: 72,
				label: "Falkon Ai Monitoring",
				path: WebRoutes.AI_MONITERING,
				component: withErrorBoundaries(AiAnalytics, "Falkon Ai Monitoring"),
				primaryIcon: FalkonAiMoniteringIcon,
				primaryDarkIcon: FalkonAiMoniteringIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: true
			},
			{
				id: 73,
				label: "Custom Attributes",
				path: WebRoutes.CUSTOM_ATTRIBUTES,
				component: withErrorBoundaries(CustomAttributesComponent, "Custom-attributes"),
				primaryIcon: ContactsPrimaryIcon,
				primaryDarkIcon: ContactsPrimaryDarkIcon,
				roles: [2, 3, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 74,
				label: "Web Form",
				path: WebRoutes.WEBFORM,
				component: withErrorBoundaries(WebForm, "Web Form"),
				roles: [2, 4],
				primaryIcon: IntegrationPrimaryIcon,
				primaryDarkIcon: IntegrationPrimaryDarkIcon,
				authenticationRequired: true,
				isSideMenu: false,
				isUserMenu: false,
			},
			{
				id: 75,
				label: "Web-Form History",
				path: WebRoutes.WEB_FORM_HISTORY,
				component: withErrorBoundaries(WebFormHistory, "Web-Form History"),
				roles: [2, 4],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true
			},
			{
				id: 76,
				label: "Web Form",
				path: WebRoutes.WEB_FORM_END_USER_VIEW,
				component: withErrorBoundaries(EndUserWebFormComponent, "Web Form redirect"),
				roles: [2, 3, 4],
				authenticationRequired: false,
				isSideMenu: false
			},
			{
				id: 77,
				label: "Bulk Add Users",
				path: WebRoutes.NEW_USERS_IMPORT,
				component: withErrorBoundaries(ImportUsersComponent, "Bulk Add Users"),
				primaryIcon: UsersPrimaryIcon,
				primaryDarkIcon: UsersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true,
				hide: false
			},
			{
				id: 78,
				label: "Bulk Host Numbers",
				path: WebRoutes.NEW_PHONE_NUMBER_BULK_IMPORT,
				component: withErrorBoundaries(NewNumberBulkImportComponent, "Bulk Host Numbers"),
				primaryIcon: PhoneNumbersPrimaryIcon,
				primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true,
				hide: false
			},
			{
				id: 79,
				label: "Import Reports",
				path: WebRoutes.NEW_PHONE_NUMBER_IMPORT_REPORTS,
				component: withErrorBoundaries(PhoneHostImportReports, "Import Reports"),
				primaryIcon: PhoneNumbersPrimaryIcon,
				primaryDarkIcon: PhoneNumbersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true,
				hide: false
			},
			{
				id: 80,
				label: "User Import Reports",
				path: WebRoutes.NEW_USERS_IMPORT_REPORTS,
				component: withErrorBoundaries(UserImportReports, "User Import Reports"),
				primaryIcon: UsersPrimaryIcon,
				primaryDarkIcon: UsersPrimaryDarkIcon,
				roles: [1],
				authenticationRequired: true,
				isSideMenu: false,
				exact: true,
				hide: false
			},
		].filter(x => !x.hide);

		existing_routes = routes;
		user_id = userId;
	}
	return existing_routes
}

export const getAuthorisedRoutes = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
	return Routes().filter(route => route.authenticationRequired && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getSideMenus = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
	let routes = Routes();
	const AiSettings = store.getState().Settings.Settings;
	if (AiSettings?.find(x => x.Code === "AI")?.Value?.toString()?.toLowerCase() != "true") {
		routes = Routes().filter(x => x.label !== "Falkon AI")
	}
	return routes.filter(route => route.isSideMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getUserMenus = (role: number, planMetrics: PlanMetrics | UserPlanTracker): RouteModel[] => {
	return Routes().filter(route => route.isUserMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getUnAuthorisedRoutes = (): RouteModel[] => {
	return Routes().filter(route => !route.authenticationRequired)
}